import { createPromiseAction } from 'redux-saga-promise-actions';
import { PaymentDataPayload, PaymentDataResponse } from 'store/types/paymentdata';

export const getPaymentData = createPromiseAction(
  'GET_PAYMENTDATA',
  'GET_PAYMENTDATA_SUCCEEDED',
  'GET_PAYMENTDATA_FAILURE',
)<PaymentDataPayload, PaymentDataResponse, undefined>();
